var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8PlusMath50(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4D4D4D",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 23.970703 4.9726562 A 2.0002 2.0002 0 0 0 22 7 L 22 22 L 7 22 A 2.0002 2.0002 0 1 0 7 26 L 22 26 L 22 41 A 2.0002 2.0002 0 1 0 26 41 L 26 26 L 41 26 A 2.0002 2.0002 0 1 0 41 22 L 26 22 L 26 7 A 2.0002 2.0002 0 0 0 23.970703 4.9726562 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PlusMath50);
export default __webpack_public_path__ + "static/media/icons8-plus-math-50.08be6f958d545baab4a1defa8d7a665b.svg";
export { ForwardRef as ReactComponent };